import { CommonService } from './../../services/common.service';
import { ManageService } from './../../services/manage.service';
import { Component, OnInit, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { BreadcrumbComponent } from '../../breadcrumb/breadcrumb.component';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

// tslint:disable-next-line:import-blacklist
import { Observable, Subject } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { NewUpgradeItem } from '../../models/imanage.model';
import { LTEPurchaseViewModel } from '../../models/lte-details-view.model';
import { CheckoutStatusModel, CheckoutViewModel } from '../../models/check-out.model';
import { CheckOutService } from '../../services/checkout.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponse } from '../../models/api-response.model';
import { CurrentUserModel } from '../../models/account-ledger.model';




class RenewalDetails {
    constructor() {
        this.title = 'RENEWAL DETAILS';
    }
    title: string;
    vendor: string;
    endUser: string;
    program: string;
    expiryDate: string;
    opportunityId: string;
    reference: string;
    agreementNumber: string
}

class RenewalManagement {
    constructor() {
        this.title = 'RENEWAL MANAGEMENT';
    }
    title: string;
    status: string;
    comments: string
}

class Options {
    constructor() {
        this.details = [];
        this.canPurchase = true;
    }
    id: string;
    desc: string;
    total: number;
    canPurchase: boolean;
    action: string;
    details: OptionDetail[];
    isTransactable: boolean;
}

class OptionDetail {
    constructor() {
        this.isSelected = true;
    }
    stokeCode: string;
    description: string;
    serialNumber: string;
    qty: number;
    price: string;
    extendedPrice: number;
    minQty: number;
    maxQty: number;
    isTransactable: boolean;
    salesType: string;
    isSelected: boolean;
}

class ManageRenewal {
    constructor() {
        this.RenewalDetails = new RenewalDetails();
        this.RenewalManagement = new RenewalManagement();
        this.Options = [];
    }
    RenewalDetails: RenewalDetails;
    RenewalManagement: RenewalManagement;
    Options: Options[]
}

declare var $: any;

@Component({
    selector: 'app-manage-renewal-details',
    templateUrl: './manage-renewals-details.component.html',
    styleUrls: ['./manage-renewals-details.component.css']
})
export class ManageRenewalsDetails implements OnInit, OnDestroy {

    statusList: string[] = [
        'LOST',
        'OPEN',
        'OPTOUT',
        'WAIT',
        'WON'
    ]

    enquiry: string = '';

    enquiryOptions: Options;

    enquiryIndex: number;

    loadEnquiryContent: boolean = true;

    serial: string;

    status: string = '';

    comments: string = '';

    closeResult = '';

    manageRenewal: ManageRenewal = new ManageRenewal();

    loadContent: boolean = true;

    selectedStatus: string;

    vendorDictionary: any = {};

    ngUnsubscribe: Subject<void> = new Subject<void>();

    checkoutStatus: CheckoutStatusModel = {
        currentStep: '',
        firstStep: '',
        hasChosenCheckout: false,
        collectOrder: false,
        tenantDetailsRequired: ''
    };
    user$: Observable<CurrentUserModel>;
    // checkoutViewModel: CheckoutViewModel;

    @ViewChild(BreadcrumbComponent) sample: BreadcrumbComponent;
    @ViewChild("ParentWrapper", { static: true }) parentWrapper: ElementRef;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private manageService: ManageService,
        private commonService: CommonService,
        private authService: AuthService,
        private checkOutService: CheckOutService,
        private modalService: NgbModal
    ) {

    }

    ngOnInit() {

        $('#levelOne').animate({ scrollLeft: 250 }, 400);

        

        this.user$ = this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe));

        this.activatedRoute.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(params => {
            this.serial = params.get('serial');
        });

        this.manageService.currentVendorDictionary.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
            this.vendorDictionary = res;
        });

        this.activatedRoute.paramMap.pipe(
            switchMap((param) => { this.loadContent = false; return this.manageService.GetRenewalDetails(param.get('serial')) }
            )).pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(res => {

                this.manageRenewal = new ManageRenewal();
                //renewalDetails
                const renewalDetails = res.out[0];
                this.manageRenewal.RenewalDetails.vendor = renewalDetails.out_vendor;
                this.manageRenewal.RenewalDetails.endUser = renewalDetails.out_end_user;
                this.manageRenewal.RenewalDetails.program = renewalDetails.out_program;
                this.manageRenewal.RenewalDetails.expiryDate = renewalDetails.out_expiry_date;
                this.manageRenewal.RenewalDetails.opportunityId = renewalDetails.out_opportunity_id;
                this.manageRenewal.RenewalDetails.reference = renewalDetails.out_eu_reference;
                this.manageRenewal.RenewalDetails.agreementNumber = renewalDetails.out_agreement;


                //renewal management
                this.status = this.manageRenewal.RenewalManagement.status = renewalDetails.out_status;

                this.comments = this.manageRenewal.RenewalManagement.comments = renewalDetails.out_comments;

                //options
                const sortedRenewlOptions = this.commonService.groupBy(res.out, (val) => val.out_offer_id);

                for (let id in sortedRenewlOptions) {

                    let option = new Options();
                    const optionList = sortedRenewlOptions[id];

                    option.id = id;
                    option.desc = optionList[0].out_offer_description;
                    option.action = optionList[0].out_offer_action.toLowerCase();
                    //option.action = 'partial';
                    let totalPrice = 0;
                    optionList.forEach(element => {

                        let optionDetail = new OptionDetail();
                        optionDetail.stokeCode = element.out_sku;
                        optionDetail.description = element.out_description;
                        optionDetail.qty = parseInt(element.out_qty);
                        optionDetail.minQty = parseInt(element.out_min_qty);
                        optionDetail.maxQty = parseInt(element.out_max_qty);
                        optionDetail.price = element.out_total_price;
                        optionDetail.serialNumber = element.out_eusd_user_only_11;
                        optionDetail.extendedPrice = parseFloat(element.out_qty) * parseFloat(element.out_total_price);
                        optionDetail.salesType = element.out_sales_type;
                        optionDetail.isTransactable = element.out_transactable == "Y" ? true : false;
                        totalPrice += parseFloat(element.out_qty) * parseFloat(element.out_total_price);
                        option.details.push(optionDetail);
                    })

                    option.total = totalPrice;
                    option.isTransactable = option.details.every((element) => element.isTransactable === true);
                    this.manageRenewal.Options.push(option);
                }
                //this.commonService.applyScrollFixedHeader(this.parentWrapper);
                this.loadContent = true;
                //console.log(this.manageRenewal);
            });

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
            if (this.router.url.includes('/renewalDetails/') && !this.router.url.includes('checkout')) {
                $('#levelOne').animate({ scrollLeft: 250 }, 400);
            }

        });
    }

    showSlideToggle(action: string): boolean {
        if (action == 'exact') {
            return false;
        } else if (action == 'partial') {
            return true;
        } else {
            return false;
        }
    }

    updateRenewalStatus(): void {
        this.manageService.UpdateXRenewalHeader(this.serial, this.status, this.comments)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(res => {
                if (res.out == null) {
                    this.commonService.implementToast('Status updated failed', 'Error');
                } else {
                    if (res.out[0].out_message === 'Successful') {
                        this.commonService.implementToast('Status updated successfully', 'Success');

                        this.status = this.manageRenewal.RenewalManagement.status = res.out[0].out_status;

                        this.comments = this.manageRenewal.RenewalManagement.comments = res.out[0].out_comments;

                        this.manageService.monitorRenewalDetailsUpdate({
                            serial: res.out[0].out_serial,
                            status: res.out[0].out_status,
                            comments: res.out[0].out_comments
                        });
                    } else if (res.out?.length == 0) {
                        this.commonService.implementToast('Status updated failed', 'Error');
                    } else {
                        this.commonService.implementToast('Status updated failed', 'Error');
                    }
                }
            });


        // this.activatedRoute.paramMap.pipe(
        //     switchMap((param) => this.manageService.UpdateXRenewalHeader(param.get('serial'), this.manageRenewal.RenewalManagement.status, this.manageRenewal.RenewalManagement.comments)
        //     ))
        //     .takeUntil(this.ngUnsubscribe)
        //     .subscribe(res => {
        //         if (res.out == null) {
        //             this.commonService.implementToast('Status updated failed', 'Error');
        //         } else {
        //             if (res.out[0].out_message === 'Successful') {
        //                 this.commonService.implementToast('Status updated successfully', 'Success');
        //                 this.manageService.monitorRenewalDetailsUpdate({
        //                     serial: res.out[0].out_serial,
        //                     status: res.out[0].out_status,
        //                     comments: res.out[0].out_comments
        //                 });
        //             } else if (res.out === []) {
        //                 this.commonService.implementToast('Status updated failed', 'Error');
        //             } else {
        //                 this.commonService.implementToast('Status updated failed', 'Error');
        //             }
        //         }
        //     });

    }

    renderAreegmentNumber(number: string): string {
        if (number !== '') {
            return `| ${number}`
        } else {
            return '';
        }
    }

    confirmRenewalPurchase(option: Options): void {

        // this.showCheckOut = true;

        // $('#levelOne').animate({ scrollLeft: $('#renewalDetails').width() + 500 }, 400);

        // return;

        const upgradeItems = [] as NewUpgradeItem[];
        const optedOutItems = [] as NewUpgradeItem[];

        option.details.forEach(item => {
            if (item.isSelected) {
                const newItem = {} as NewUpgradeItem;
                newItem.description = item.description;
                //newItem.lineSeq = item.serialNumber;
                newItem.stockCode = item.stokeCode;
                newItem.qty = item.qty;
                newItem.price = item.price;
                newItem.salesType = item.salesType;
                upgradeItems.push(newItem);
            }
        });

        const purchaseModel = {} as LTEPurchaseViewModel;

        purchaseModel.serial = this.serial;

        purchaseModel.customerReference = this.manageRenewal.RenewalDetails.reference;
        // purchaseModel.originalOrderNo = this.renewalDetails.orderNo;
        // purchaseModel.originalOrderSuffix = this.renewalDetails.orderSuffix;
        let dateString: string[] = this.manageRenewal.RenewalDetails.expiryDate.split('-');
        purchaseModel.originalExpiryDate = `${dateString[1]}-${dateString[0]}-${dateString[2]}`;
        //purchaseModel.originalExpiryDate = this.manageRenewal.RenewalDetails.expiryDate;

        purchaseModel.upgradeItems = upgradeItems;

        purchaseModel.optedOutItems = optedOutItems;

        this.loadContent = false;

        this.manageService.purchase(purchaseModel).pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: any) => {
            if (value.status === true) {
                const cartIdName = value.responseMessage;
                if (value.status === true) {
                    const tempArray = cartIdName.split('/');
                    if (tempArray.length) {
                        localStorage.setItem('annuityCartId', tempArray[0]);
                    }
                    const cartId = cartIdName.substring(0, cartIdName.indexOf('/'));
                    this.checkOutService.CartCheckout(this.commonService.toNumber(cartId)).subscribe((res: CheckoutViewModel) => {
                        // this.checkOutService.monitorCurrentCheckoutViewModel(res);
                        // this.router.navigateByUrl(`/myCarts/cart/${cartIdName}`);

                        this.checkOutService.monitorCurrentCheckoutViewModel(res);


                        this.checkoutStatus.hasChosenCheckout = true;
                        this.checkoutStatus.firstStep = res.firstStep;
                        this.checkoutStatus.currentStep = res.firstStep;
                        this.loadContent = true;
                        // this child component will be emitting a change every time this function is called
                        // this.checkOutService.emitChange(this.checkoutStatus);
                        this.checkOutService.monitorCurrerntCheckoutStatusModel(this.checkoutStatus);
                        this.router.navigate([`checkout/${cartIdName}`], { relativeTo: this.activatedRoute });
                        $('#levelOne').animate({ scrollLeft: $('#renewalDetails').width() + 500 }, 400);
                    })
                    // this.router.navigateByUrl(`/myCarts/cart/${cartIdName}`);
                } else {
                    this.commonService.implementToast('Unable to create shopping cart', 'Error');
                }
            } else {
                this.commonService.implementToast('Unable to create shopping cart', 'Error');
            }
        });

    }

    optionQtyonChange(option: Options, index: number) {

        let optionDetal: OptionDetail = option.details[index];

        if (optionDetal.qty < optionDetal.minQty) {
            this.commonService.implementToast('Minimum qty for this item is ' + optionDetal.minQty.toString(), 'Error');
            option.canPurchase = false;
        } else if (optionDetal.qty > optionDetal.maxQty) {
            this.commonService.implementToast('Max qty for this item is ' + optionDetal.maxQty.toString(), 'Error');
            option.canPurchase = false;
        } else {
            optionDetal.extendedPrice = optionDetal.qty * parseFloat(optionDetal.price);
            let total = 0;
            option.details.forEach((element) => {
                total += element.extendedPrice;
            });
            option.total = total;
            option.canPurchase = true;
        }

    }

    fitlerOptions(option: Options): boolean {

        let result = option.details.filter(m => m.isSelected).length === 0;

        return result
    }

    onLoading(currentLoadingStatus: boolean) {
        this.loadContent = !currentLoadingStatus;
    }

    open(content: any, option: Options, index: number) {

        this.enquiryOptions = option;

        this.enquiryIndex = index;

        $('#exampleModalCenter').modal();

        // this.modalService.open(content, { centered: true }).result.then((result) => {
        //     this.closeResult = `Closed with: ${result}`;
        // }, (reason) => {
        //     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        // });
    }

    closeModal() {
        $('#exampleModalCenter').modal('hide');
    }
    // private getDismissReason(reason: any): string {
    //     if (reason === ModalDismissReasons.ESC) {
    //         return 'by pressing ESC';
    //     } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    //         return 'by clicking on a backdrop';
    //     } else {
    //         return `with: ${reason}`;
    //     }
    // }

    sendEnquiry() {

        let purchaseModel: any[] = [];

        this.enquiryOptions.details.forEach(item => {
            if (item.isSelected) {
                const newItem = <any>{};
                newItem.description = item.description;
                //newItem.lineSeq = item.serialNumber;
                newItem.stockCode = item.stokeCode;
                newItem.qty = item.qty;
                newItem.price = item.price;
                newItem.extendedPrice = item.extendedPrice;
                purchaseModel.push(newItem);
            }
        });

        this.loadEnquiryContent = false;

        this.manageService.Enquiry(this.manageRenewal.RenewalDetails, this.manageRenewal.RenewalManagement, purchaseModel, this.enquiry, `OPTION ${this.enquiryIndex + 1} - ${this.enquiryOptions.desc}`).subscribe((res: ApiResponse) => {
            this.loadEnquiryContent = true;
            this.enquiry = '';
            this.enquiryOptions = null;
            this.enquiryIndex = null;
            $('#exampleModalCenter').modal('hide');
            if (res.status) {
                this.commonService.implementToast('Enquiry has been sent successfully', 'Success');
            } else {
                this.commonService.implementToast('Failed to send enquiry', 'Error');
            }
        });

    }


    // isOptionTransactable(option: Options): boolean {
    //     return option.details.every((element) => element.isTransactable === true);
    // }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    close() {
        //$('#levelOne').animate({ scrollLeft: -250 }, 400);
        this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }


}
